module.exports = __webpack_public_path__ + "static/media/staff leave.95b3b471.svg";